var map = {
	"./anmol.json": [
		89676,
		676
	],
	"./aqualite.json": [
		39063,
		63
	],
	"./bata.json": [
		87553,
		553
	],
	"./bch.json": [
		30920,
		920
	],
	"./bikaji.json": [
		26739,
		739
	],
	"./borosil.json": [
		76837,
		837
	],
	"./calkn.json": [
		77228,
		228
	],
	"./cavin-kare.json": [
		10126,
		126
	],
	"./century-ply.json": [
		59663,
		663
	],
	"./default.json": [
		76076,
		76
	],
	"./dermawear.json": [
		26939,
		939
	],
	"./gautam-garments.json": [
		17180,
		180
	],
	"./gullak.json": [
		4559,
		559
	],
	"./hirshita-leggings.json": [
		48222,
		222
	],
	"./jqr.json": [
		28636,
		636
	],
	"./lancer-footwear.json": [
		63764,
		764
	],
	"./nagina.json": [
		24967,
		967
	],
	"./ozone.json": [
		45654,
		654
	],
	"./seedworks.json": [
		6008,
		8
	],
	"./siyaram.json": [
		13035,
		35
	],
	"./skdreams.json": [
		81125,
		125
	],
	"./sudama.json": [
		8182,
		182
	],
	"./talbros.json": [
		37266,
		266
	],
	"./tibcon.json": [
		24474,
		474
	],
	"./ultimatrue.json": [
		54955,
		955
	],
	"./vijeta.json": [
		17672,
		672
	],
	"./vox.json": [
		59848,
		848
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86790;
module.exports = webpackAsyncContext;